import { IconButton as BaseIconButton, styled } from "@100mslive/roomkit-react";

const IconButton = styled(BaseIconButton, {
  width: "$14",
  height: "$14",
  r: "$1",
});

export default IconButton;
